var React = require('react');

function Fortizar (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:none;stroke:#000;stroke-linecap:square;stroke-linejoin:bevel;stroke-width:2px;}")),React.createElement("title",{"key":1},"Fortizar"),React.createElement("path",{"id":"path1618-3","className":"cls-1","d":"M114,55.67H80.67V22.33H47.33V55.67H14v50H114Z","key":2})]);
}

Fortizar.defaultProps = {"id":"svg8","viewBox":"0 0 128 128"};

module.exports = Fortizar;

Fortizar.default = Fortizar;
